<section
  class="rounded-2xl rounded-b-none border border-neutral-200 bg-white p-4 shadow-sm
         dark:border-neutral-800 dark:bg-neutral-800"
>
  <!-- Header -->
  <div class="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
    <div
      class="text-[11px] font-extrabold uppercase tracking-wider
             text-neutral-700 dark:text-neutral-400"
    >
      Inconsistências (validação do details)
    </div>

    <!-- Summary pill -->
    <div
      class="inline-flex items-center gap-2 rounded-full border px-3 py-1
             text-xs font-semibold"
      [ngClass]="severitySummary().severity === 'error'
        ? 'border-red-200 bg-red-50 text-red-700 dark:border-red-900/50 dark:bg-red-900/20 dark:text-red-400'
        : severitySummary().severity === 'warning'
          ? 'border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-900/50 dark:bg-amber-900/20 dark:text-amber-400'
          : 'border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-900/50 dark:bg-blue-900/20 dark:text-blue-400'"
    >
      <span
        class="h-2.5 w-2.5 rounded-full border"
        [ngClass]="severitySummary().severity === 'error'
          ? 'bg-red-500 border-red-200 dark:border-red-900/50'
          : severitySummary().severity === 'warning'
            ? 'bg-amber-500 border-amber-200 dark:border-amber-900/50'
            : 'bg-blue-500 border-blue-200 dark:border-blue-900/50'"
      ></span>

      <span>{{ severitySummary().label }}</span>
      <span class="opacity-80">({{ inconsistencies.length }})</span>
    </div>
  </div>

  <!-- Empty state -->
  @if (inconsistencies.length === 0) {
    <div class="mt-3 text-sm text-neutral-600 dark:text-neutral-400">
      Nenhuma inconsistência encontrada com as validações atuais.
    </div>
  } @else {
    <div class="mt-3 space-y-2">
      @for (it of inconsistencies; track $index) {
        <div
          class="flex items-start gap-3 rounded-xl border border-neutral-100
                 bg-neutral-50 p-3
                 dark:border-neutral-700 dark:bg-neutral-900/50"
        >
          <!-- Severity dot -->
          <span
            class="mt-1 h-2.5 w-2.5 rounded-full border"
            [ngClass]="it.severity === 'error'
              ? 'bg-red-500 border-red-200 dark:border-red-900/50'
              : it.severity === 'warning'
                ? 'bg-amber-500 border-amber-200 dark:border-amber-900/50'
                : 'bg-blue-500 border-blue-200 dark:border-blue-900/50'"
          ></span>

          <!-- Message -->
          <div class="min-w-0 flex-1">
            <div class="text-sm text-neutral-900 dark:text-white">
              {{ it.message }}
            </div>

            @if (it.code) {
              <div class="mt-1 text-xs font-mono text-neutral-500 dark:text-neutral-500">
                {{ it.code }}
              </div>
            }
          </div>

          <!-- Invoice text -->
          @if (it.invoice) {
            <div class="mt-1 text-xs font-mono text-neutral-700 dark:text-neutral-300">
              {{ it.invoice }}
            </div>
          }

          <!-- Action / Badge -->
          @if (it.code === 'INVOICE_PENDING' && isAllowedToReprocess) {
            <app-button
              [icon]="isReprocessingOrder && !hasActiveWorkflow ? 'refresh-cw' : 'lock'"
              size="small"
              color="warning"
              rounded="full"
              [disabled]="!isReprocessingOrder || hasActiveWorkflow"
              app-tool-tip
              [tooltip-text]="
                  hasActiveWorkflow
                    ? 'Já existe um workflow ativo para este pedido.'
                    : isReprocessingOrder
                      ? 'Reprocessar pedido'
                      : 'Este pedido não atende aos critérios para reprocessamento.'
"
              (click)="onReprocessClick()"
            >
            </app-button>
          } @else {
            <span
              class="shrink-0 rounded-full border px-2 py-0.5
                     text-[11px] font-extrabold uppercase"
              [ngClass]="it.severity === 'error'
                ? 'border-red-200 bg-red-50 text-red-700 dark:border-red-900/50 dark:bg-red-900/20 dark:text-red-400'
                : it.severity === 'warning'
                  ? 'border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-900/50 dark:bg-amber-900/20 dark:text-amber-400'
                  : 'border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-900/50 dark:bg-blue-900/20 dark:text-blue-400'"
            >
              {{ it.severity }}
            </span>
          }
        </div>
      }
    </div>
  }
</section>
